import React, { useState, useEffect } from "react";
import RequestItem from "./RequestItem";
import AddRequestModal from "./AddRequestModal";
import api from '../../api/api';
import { toJalaliDate } from '../../utils/dateUtils';

const RequestsCard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [requestsData, setRequestsData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRequests = async () => {
    try {
      const res = await api.get('/requests/');
      setRequestsData(res.data);
    } catch (error) {
      console.error('Error fetching requests:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  if (loading) return <div className="p-4 text-center">در حال بارگذاری...</div>;

  const handleAddRequest = async (newRequest) => {
    try {
      await api.post('/requests/', newRequest);
      fetchRequests();
      setIsModalOpen(false);
    } catch (error) {
      console.error('Error creating request:', error);
      alert('خطا در ایجاد درخواست');
    }
  };

  return (
    <div className="bg-white p-4 md:p-6 rounded-3xl border border-slate-900/10 shadow-[0_0_25px_rgba(15,23,42,0.22)] flex flex-col h-[400px] md:h-full min-h-0 transition-all duration-300 hover:shadow-[0_0_35px_rgba(15,23,42,0.35)] ring-2 ring-blue-500/50" dir="rtl">
      <div className="flex justify-between items-center mb-4 flex-shrink-0">
        <h3 className="text-base font-bold text-slate-800">درخواست‌ها</h3>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setIsModalOpen(true)}
            className="text-gray-400 hover:text-slate-700 text-lg cursor-pointer"
          >
            ＋
          </button>
          <button className="text-gray-400 hover:text-slate-700 font-bold cursor-pointer">···</button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto min-h-0 pr-1 pb-2 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-slate-50 [&::-webkit-scrollbar-thumb]:bg-slate-200 [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-slate-300">
        <div className="flex flex-col divide-y divide-gray-100">
          {requestsData.map((request) => (
            <RequestItem
              key={request.id}
              name={request.title || request.name}
              date={toJalaliDate(request.created_at)}
              description={request.description}
              status={request.status}
              avatarUrl={request.avatarUrl}
            />
          ))}
        </div>
      </div>

      {isModalOpen && (
        <AddRequestModal
          onClose={() => { setIsModalOpen(false); }}
          onAdd={handleAddRequest}
        />
      )}
    </div>
  );
};

export default RequestsCard;